import { Button, Typography, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import SoftBox from "components/SoftBox";
import PropTypes from "prop-types";
import Input from "components/Input";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { commonComboboxLabelStyle } from "styles/muiStyles";
import dataSearchUserManager from "../data";
import { useColorTheme } from "../../../context/ColorThemeContext";

function SearchUserManager({ clickSearch, setSearchData, searchData }) {
  const colors = useColorTheme();

  const stateDataOptions = dataSearchUserManager.stateData;
  const [showSearch, setShowSearch] = useState(true);

  useEffect(() => {
    const onEnterKeyEvent = (e) => {
      if (e.key === "Enter") {
        clickSearch();
      }
    };

    document.addEventListener("keypress", onEnterKeyEvent);
    return () => {
      document.removeEventListener("keypress", onEnterKeyEvent);
    };
  }, [clickSearch]);

  const CustomSelect = styled(Select)({
    "&.MuiOutlinedInput-root .MuiSelect-select": {
      paddingLeft: "0px !important",
      paddingRight: "0.75rem !important",
      marginTop: "5px !important",
      textAlign: "left",
    },
    backgroundColor: "#fff",
    height: "40px !important",
  });
  return (
    <SoftBox
      style={{
        backgroundColor: "white",
        padding: "10px 24px",
        borderRadius: "8px",
        marginBottom: "20px",
      }}
    >
      <Grid container style={{ display: "flex", alignItems: "left" }}>
        <Grid item>
          <Typography fontSize="18px" variant="h6" fontWeight="bold" gutterBottom>
            Thông tin tìm kiếm
          </Typography>
        </Grid>
        <Button
          sx={{
            "& .material-icons, & .material-icons-round, & svg, & span": {
              fontSize: "30px !important", // Kích thước mới
              marginTop: "-5px",
            },
          }}
          style={{ color: "black" }}
          onClick={() => setShowSearch(!showSearch)}
        >
          {showSearch ? <ExpandLessIcon fontSize="large" /> : <ExpandMoreIcon fontSize="large" />}
        </Button>
      </Grid>
      {showSearch && (
        <Grid paddingBottom="8px" container spacing={1}>
          <Grid item xs={12} sm={5} xl={4}>
            <Input
              label="Tên đăng nhập"
              style={{ color: "black" }}
              onChange={(event) =>
                setSearchData((prevState) => ({
                  ...prevState,
                  username: event.target.value,
                }))
              }
              value={searchData.username}
              type="text"
              customProp="Custom Property"
            />
          </Grid>
          <Grid item xs={12} sm={5} xl={4}>
            <Input
              label="Tên người dùng"
              style={{ color: "black" }}
              value={searchData.fullName}
              onChange={(event) =>
                setSearchData((prevState) => ({
                  ...prevState,
                  fullName: event.target.value,
                }))
              }
              type="text"
              customProp="Custom Property"
            />
          </Grid>
          <Grid item xs={12} sm={5} xl={4}>
            <FormControl
              fullWidth
              className="formControl"
              sx={{
                marginTop: "10px !important",
              }}
            >
              <InputLabel shrink={true} sx={commonComboboxLabelStyle} id="status-label">
                Trạng thái
              </InputLabel>
              <CustomSelect
                className="form-field"
                value={searchData.enabled}
                onChange={(event) =>
                  setSearchData((prevState) => ({
                    ...prevState,
                    enabled: event.target.value,
                  }))
                }
                sx={{
                  "& .MuiSelect-select": {
                    paddingLeft: "0px !important", // Specific padding-left set to 0px
                    paddingRight: "0.75rem !important", // Right padding as you want
                    marginTop: "5px !important", // Margins for the select element
                  },
                  backgroundColor: "#fff",
                  height: "40px !important", // Ensure the height is 40px
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      overflow: "auto !important",
                    },
                  },
                  style: { maxHeight: "40vh", overflow: "auto !important" },
                }}
                labelId="status-label"
                label="Trạng thái"
              >
                {stateDataOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </CustomSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={5} xl={4}>
            <Input
              label="Số điện thoại"
              style={{ color: "black" }}
              value={searchData.phone}
              onChange={(event) =>
                setSearchData((prevState) => ({
                  ...prevState,
                  phone: event.target.value,
                }))
              }
              type="text"
              customProp="Custom Property"
            />
          </Grid>
          <Grid item xs={12} sm={5} xl={4}>
            <Input
              label="Email"
              style={{ color: "black" }}
              value={searchData.email}
              onChange={(event) =>
                setSearchData((prevState) => ({
                  ...prevState,
                  email: event.target.value,
                }))
              }
              type="text"
              customProp="Custom Property"
            />
          </Grid>
          <Grid item xs={12} sm={4} xl={12}>
            <div
              style={{
                height: "80%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <Button
                sx={{
                  "&.MuiButton-root.MuiButton-contained": {
                    boxShadow: "none !important",
                    backgroundColor: colors.popupBackground || "var(--blue-blue-100)",
                    fontWeight: "normal",
                    height: "36px !important",
                    width: "129px",
                    color: colors.popupText || "white",
                  },
                  "&.MuiButton-root": {
                    minHeight: "36px !important",
                  },
                }}
                variant="contained"
                onClick={clickSearch}
              >
                Tìm kiếm
              </Button>
            </div>
          </Grid>
        </Grid>
      )}
    </SoftBox>
  );
}
SearchUserManager.propTypes = {
  clickSearch: PropTypes.func.isRequired,
  setSearchData: PropTypes.func.isRequired,
  searchData: PropTypes.shape.isRequired,
};

export default SearchUserManager;
